export default __webpack_public_path__ + "static/media/education.d332008f.webp";